import { baseStyleSheet } from '../../../styles/styles';
import { styleSheet } from './styles';
import { StyleDeclaration, css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	ctaText: string;
	onClick(): void;
	styles?: StyleDeclaration[];
	text: string;
}

export const BlueCardWithCta: React.FC<IProps> = ({ ctaText, onClick, styles = [], text }) => (
	<div className={css(styleSheet.container, ...styles)}>
		<p className={css(styleSheet.text)}>{text}</p>
		<button className={css(baseStyleSheet.ctaButton)} onClick={onClick}>
			{ctaText}
		</button>
	</div>
);
